var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "ul",
      {
        staticClass: "accordion",
        attrs: {
          id: "sow-accordion",
          "data-accordion": "",
          "data-deep-link": "true",
          "data-allow-all-closed": "true",
          "data-multi-expand": "true",
          "data-update-history": "true",
          "data-deep-link-smudge": "500",
        },
      },
      [
        _c(
          "li",
          {
            staticClass: "accordion-item is-active",
            attrs: { "data-accordion-item": "" },
          },
          [
            _c("a", { staticClass: "accordion-title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("tender.sow.generalDesc")) +
                  "\n        "
              ),
              _c(
                "div",
                { staticClass: "sow-hint" },
                [
                  _c("Popover", {
                    attrs: {
                      text: _vm.$t("tender.sow.generalDescHint"),
                      position: "bottom-right",
                      width: 500,
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "accordion-content",
                attrs: { id: "deeplink1", "data-tab-content": "" },
              },
              [
                _c("TinymceEditor", {
                  attrs: { customizeToolbar: _vm.editorToolbar },
                  model: {
                    value: _vm.generalDesc,
                    callback: function ($$v) {
                      _vm.generalDesc = $$v
                    },
                    expression: "generalDesc",
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "accordion-item is-active",
            attrs: { "data-accordion-item": "" },
          },
          [
            _c("a", { staticClass: "accordion-title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("tender.sow.generalSpec")) +
                  "\n        "
              ),
              _c(
                "div",
                { staticClass: "sow-hint" },
                [
                  _c("Popover", {
                    attrs: {
                      text: _vm.$t("tender.sow.generalSpecHint"),
                      position: "bottom-right",
                      width: 500,
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "accordion-content",
                attrs: { id: "deeplink2", "data-tab-content": "" },
              },
              [
                _c("TinymceEditor", {
                  attrs: { customizeToolbar: _vm.editorToolbar },
                  model: {
                    value: _vm.generalSpec,
                    callback: function ($$v) {
                      _vm.generalSpec = $$v
                    },
                    expression: "generalSpec",
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "accordion-item is-active",
            attrs: { "data-accordion-item": "" },
          },
          [
            _c("a", { staticClass: "accordion-title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("tender.sow.partiSpec")) +
                  "\n        "
              ),
              _c(
                "div",
                { staticClass: "sow-hint" },
                [
                  _c("Popover", {
                    attrs: {
                      text: _vm.$t("tender.sow.partiSpecHint"),
                      position: "bottom-right",
                      width: 500,
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "accordion-content",
                attrs: { id: "deeplink3", "data-tab-content": "" },
              },
              [
                _c("TinymceEditor", {
                  attrs: { customizeToolbar: _vm.editorToolbar },
                  model: {
                    value: _vm.particularDesc,
                    callback: function ($$v) {
                      _vm.particularDesc = $$v
                    },
                    expression: "particularDesc",
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "accordion-item is-active",
            attrs: { "data-accordion-item": "" },
          },
          [
            _c("a", { staticClass: "accordion-title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("tender.sow.techSpec")) +
                  "\n        "
              ),
              _c(
                "div",
                { staticClass: "sow-hint" },
                [
                  _c("Popover", {
                    attrs: {
                      text: _vm.$t("tender.sow.techSpecHint"),
                      position: "bottom-right",
                      width: 500,
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "accordion-content",
                attrs: { id: "deeplink4", "data-tab-content": "" },
              },
              [
                _c("TinymceEditor", {
                  attrs: { customizeToolbar: _vm.editorToolbar },
                  model: {
                    value: _vm.technicalDesc,
                    callback: function ($$v) {
                      _vm.technicalDesc = $$v
                    },
                    expression: "technicalDesc",
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }